import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCloseOdc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1010 10A10.011 10.011 0 0010 0zm4.045 12.866a.417.417 0 010 .589l-.589.589a.417.417 0 01-.589 0L10 11.178l-2.866 2.867a.417.417 0 01-.589 0l-.589-.589a.417.417 0 010-.589L8.822 10 5.955 7.134a.417.417 0 010-.589l.589-.589a.417.417 0 01.589 0L10 8.822l2.866-2.866a.417.417 0 01.589 0l.589.589a.417.417 0 010 .589L11.178 10z",
    fill: "#fff"
  })));
}

export { SvgCloseOdc as ReactComponent };
//# sourceMappingURL=closeOdc.svg.js.map
